import React, {useEffect, useState} from 'react';
import {PopupDialog} from 'app/utils/modals/PopupDialog';
import {modalsStore} from 'app/store/global';
import Get from 'app/utils/Get';
import Post from 'app/utils/Post';
import I18n from 'app/i18n';
import LazyImage from 'app/helpers/LazyImage';
import {DEFAULT} from 'app/utils/Consts';
import {getImageDomain} from 'app/utils';

interface Avatar {
  id: string;
  url: string;
}

interface Props {
  popupId: string;
  profile_image: string;
  changeAvatar: (image: string) => void;
}

const PopupChangeAvatar = (props: Props): React.ReactNode => {
    const [avatars, setAvatars] = useState<Avatar[]>([]);
    const [activeImg, setActiveImg] = useState<string>(DEFAULT);

    useEffect(() => {
        new Get({url: '/avatars'})
            .execute()
            .then(response => {
                if (response.ok) {
                    response.json().then(json => {
                        const [avatarsArray] = json.avatars;

                        if (Array.isArray(avatarsArray)) {
                            const findActiveImg = avatarsArray.find(img => img.url === props.profile_image);
                            setAvatars(avatarsArray);

                            if (findActiveImg) {
                                setActiveImg(findActiveImg.id);
                            }
                        }
                    });
                }
            });
    }, []);

    const selectAvatar = (id: string) => () => setActiveImg(id === activeImg ? DEFAULT : id);

    const saveAvatar = () => () => {
        new Post({
            url: `/avatars/${activeImg}/set_avatar`
        })
            .execute()
            .then(response => {
                if (response.ok) {
                    const selected = avatars.find(a => a.id === activeImg);
                    props.changeAvatar(selected ? selected.url : DEFAULT);
                    modalsStore.hideModal(props.popupId);
                }
            });
    };

    return (
        <PopupDialog id={props.popupId}>
            <div className="popup__content">
                <h2 className="popup__header">{I18n.t('select_avatar')}</h2>
                <div className="popup__content-box">
                    {avatars.map(avatar => <div
                        key={avatar.id}
                        className={`popup__content-image ${avatar.id === activeImg ? 'popup__content-image--active' : ''}`}
                        onClick={selectAvatar(avatar.id)}
                    >
                        <LazyImage image={
                            {
                                name: 'Profile picture option',
                                url: getImageDomain(false) + avatar.url
                            }
                        }/>

                    </div>)}
                </div>
                <button className="popup__btn btn" onClick={saveAvatar()}>
                    {I18n.t('save')}
                </button>
            </div>
        </PopupDialog>
    );
};

export default PopupChangeAvatar;
